import { store } from '@/store/vuex/index'

export function can(right: string) {
  return store.getters['acl/can'](right)
}
